/* External */
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

/* Style */
import './DetailsSelector.scss';

function DetailsSelector({
  title = '',
  type = '',
  description = '',
  originalTitle = '',
  ageRating = '',
  ratingDescription = '',
  ratingWarning = '',
  genres = '',
  metadata = '',
  intl: { formatMessage } = '',
}) {
  const typeLabels = {
    MOVIE: formatMessage({ id: 'vod.about', defaultMessage: 'About this movie' }),
    SERIE: formatMessage({ id: 'serie.about', defaultMessage: 'About this serie' }),
  };
  const defaultLabel = formatMessage({ id: 'live.about', defaultMessage: 'About this content' });

  const textLabel = type ? typeLabels[type] : defaultLabel;

  const warnings = ratingWarning && ratingWarning.join(', ');

  return (
    <div className="dtv-details-selector dtv-html5-c-more-like-this">
      <div className="dtv-details-selector-header mb-1">
        <p className="dtv-details-selector__subtitle">{textLabel}</p>
        <h1 className="dtv-details-selector__title bold">
          {title}
        </h1>
        <span className="dtv-details-selector__subtitle">{originalTitle}</span>
      </div>

      <p className="dtv-details-selector__description mt-3 mb-1">
        {description}
      </p>

      <div className="dtv-details-selector__row mt-1 mb-1">
        <hr className="dtv-html5-c-focusable-link__line" />
      </div>

      {genres && (
      <div className="dtv-details-selector__row">
        <div className="col-2">
          <strong className="dtv-details-selector__label bold">
            {formatMessage({
              id: 'details.genre',
              defaultMessage: 'Genre',
            })}
            :
          </strong>
        </div>
        <div className="col-10">
          <span className="dtv-details-selector__text">
            {genres}
          </span>
        </div>
      </div>
      )}

      {ageRating && (
      <div className="dtv-details-selector__row">
        <div className="col-2">
          <strong className="dtv-details-selector__label bold dtv-details-selector__rating-classification">
            {formatMessage({
              id: 'details.classification',
              defaultMessage: 'Classification',
            })}
            :
          </strong>
        </div>
        <div className="col-10 d-flex">
          {metadata && <p className="dtv-details-selector-footer-gender-list">{metadata}</p>}

          <span className="column">
            {ageRating}
          </span>
          <span className="column d-inline">
            <span className="dtv-details-selector__label">
              <div className="dtv-details-selector__label--bigger d-flex dtv-details-selector__warning-description">{ratingDescription}</div>
              <div className="dtv-details-selector__label--minor dtv-details-selector__rating-warning">{warnings}</div>
            </span>
          </span>
        </div>
      </div>
      )}
    </div>
  );
}

DetailsSelector.propTypes = {
  title: PropTypes.node,
  type: PropTypes.node,
  originalTitle: PropTypes.node,
  description: PropTypes.node,
  ageRating: PropTypes.node,
  ratingDescription: PropTypes.node,
  ratingWarning: PropTypes.node,
  genres: PropTypes.node,
  metadata: PropTypes.node,
  intl: PropTypes.shape(),
};

export default injectIntl(DetailsSelector);
